import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  ShieldCheck, Clock, MapPin, Truck, Award, CheckCircle2, 
  AlertTriangle, PhoneCall, DollarSign, ChevronLeft, Wrench, Zap,
  BatteryCharging, Gauge, Key, ArrowDownCircle, ChevronDown, ChevronUp,
  Navigation, Sparkles
} from 'lucide-react';
import './HomePillarContent.css';

const HomePillarContent = ({ phoneNumber = '01044844492' }) => {
  const [activeFaq, setActiveFaq] = useState(null);

  const toggleFaq = (index) => {
    setActiveFaq(activeFaq === index ? null : index);
  };

  const regionalHubs = [
    {
      title: "ونش إنقاذ التجمع الخامس والقاهرة الجديدة",
      time: "10 دقائق",
      roads: "شارع التسعين الشمالي والجنوبي، محور المشير، طريق السويس، الدائري الأوسطي",
      desc: "تمركز دائم في قلب التجمع الخامس يغطي المستثمرين، النرجس، الياسمين، اللوتس، ومول كايرو فستيفال سيتي. أوناش سطحة مجهزة للسيارات الفاخرة والكهربائية مع تصاريح دخول للكمبوندات السكنية المغلقة.",
      link: "/areas/التجمع الخامس"
    },
    {
      title: "ونش إنقاذ المعادي وطريق الأوتوستراد",
      time: "10-15 دقيقة",
      roads: "شارع 9، كورنيش النيل، دجلة المعادي، زهراء المعادي، صقر قريش، الأوتوستراد",
      desc: "نغطي كافة أحياء المعادي القديمة والجديدة ومدخل المقطم ونزلة الدائري عند المنيب والمعادي. سطحات هيدروليكية جاهزة لرفع سيارات الأعطال والحوادث ونقلها لمراكز الصيانة المعتمدة بصقر قريش والقطامية.",
      link: "/areas/المعادي"
    },
    {
      title: "ونش إنقاذ مدينة نصر ومصر الجديدة وشيراتون",
      time: "10 دقائق",
      roads: "شارع عباس العقاد، مكرم عبيد، طريق النصر، صلاح سالم، النزهة الجديدة، مساكن شيراتون",
      desc: "استجابة فائقة السرعة في أكثر أحياء القاهرة حيوية. أوناش سحب وشحن بطاريات سريعة متمركزة قرب سيتي ستارز، النادي الأهلي، وطريق المطار لنقل المركبات داخل وخارج القاهرة بأمان تام.",
      link: "/areas/مدينة نصر"
    },
    {
      title: "ونش إنقاذ 6 أكتوبر والشيخ زايد وحدائق الأهرام",
      time: "12 دقيقة",
      roads: "محور 26 يوليو، وصلة دهشور، طريق الواحات، المحور المركزي، طريق الإسكندرية الصحراوي",
      desc: "تغطية شاملة لجميع أحياء أكتوبر والشيخ زايد (بيفرلي هيلز، الخمائل، سوديك، مول العرب، مول مصر) وحتى بوابات الصحراوي ومطار سفنكس مع خدمة إنقاذ سيارات الدفع الرباعي والملاكي.",
      link: "/areas/الشيخ زايد"
    },
    {
      title: "ونش إنقاذ الشروق ومدينتي والرحاب وبدر",
      time: "15 دقيقة",
      roads: "طريق السويس الصحراوي، طريق الإسماعيلية، محور الأمل، مدخل العاصمة الإدارية",
      desc: "خدمة طوارئ متخصصة لسكان مدن شرق القاهرة الجديدة والعاصمة الإدارية. أوناش سطحة كاملة مؤمنة لنقل السيارات بين المدن الجديدة والمراكز الرئيسية في القاهرة والجيزة.",
      link: "/areas/مدينتي"
    },
    {
      title: "ونش إنقاذ الدقي والمهندسين والعجوزة والزمالك",
      time: "10 دقائق",
      roads: "شارع جامعة الدول العربية، البطل أحمد عبد العزيز، شارع التحرير، شارع النيل، ميدان لبنان",
      desc: "تمركز حيوي في قلب محافظة الجيزة لخدمة مناطق وسط البلد، الدقي، والمهندسين. أوناش مجهزة للتعامل مع الشوارع المزدحمة والجراجات تحت الأرض بأعلى درجات الاحترافية والحرص.",
      link: "/areas/الدقي"
    },
    {
      title: "ونش إنقاذ الإسكندرية والساحل الشمالي والعلمين",
      time: "15-25 دقيقة",
      roads: "طريق مصر إسكندرية الصحراوي، محور المحمودية، الكورنيش، طريق الساحل الدولي، العلمين الجديدة",
      desc: "أسطول إنقاذ بحري وبري متمركز في عروس البحر الأبيض المتوسط يغطي سموحة، ميامي، العجمي، سيدي بشر، برج العرب، وقرى الساحل الشمالي حتى مطروح مع إمكانية نقل السيارات إلى القاهرة.",
      link: "/areas/الإسكندرية"
    },
    {
      title: "ونش إنقاذ الطريق الدائري والمحاور السريعة",
      time: "10 دقائق",
      roads: "الدائري الإقليمي، الدائري الأوسطي، محور روض الفرج، محور الضبعة، طريق الكريمات",
      desc: "نقاط تمركز استراتيجية عند كافة النزلات والمطالع الحيوية لتأمين المسافرين على مدار 24 ساعة. معدات انتشال ثقيلة للحوادث وسحب السيارات المقلوبة على الطرق الحرة والسريعة.",
      link: "/areas/الطريق الدائري"
    }
  ];

  const detailedFaqs = [
    {
      q: "كم يستغرق وصول ونش الإنقاذ إلى موقعي بعد الاتصال؟",
      a: "بفضل انتشار أسطولنا المكون من أكثر من 40 نقطة تمركز في الميادين العامة، المحاور السريعة، ومداخل المحافظات، يستغرق وصول أقرب ونش إليك ما بين 10 إلى 15 دقيقة فقط داخل المدن الكبرى (القاهرة، الجيزة، الإسكندرية) وما بين 15 إلى 25 دقيقة على الطرق الصحراوية والسريعة."
    },
    {
      q: "كيف يتم حساب تكلفة وسعر ونش إنقاذ السيارات؟",
      a: "يتم تحديد السعر وفق مسافة النقل بالكيلومتر ونوع السيارة (سيدان، SUV، شاحنة خفيفة، معدات ثقيلة). في ونش محمد بحر، نتفق معك على التكلفة الثابتة والنهائية قبل تحرك الونش بدون أي رسوم خفية أو إكراميات إجبارية، مع تطبيق خصم 50% الفوري على جميع الخدمات."
    },
    {
      q: "هل خدمة ونش الإنقاذ متوفرة 24 ساعة وفي أيام الإجازات الرسمية؟",
      a: "نعم، خدمات ونش إنقاذ محمد بحر تعمل على مدار 24 ساعة يومياً، 7 أيام في الأسبوع، بما في ذلك العطلات الرسمية والأعياد والظروف الجوية الصعبة (الأمطار والشبورة المائية)، بنفس الأسعار والتعريفة المعتمدة دون أي زيادة ليلية."
    },
    {
      q: "ما نوع الونش المناسب لسيارتي (السطحة أم الونش العادي)؟",
      a: "للسيارات الحديثة، الفارهة (مرسيدس، بي إم دبليو، أودي)، سيارات الدفع الرباعي المستمر (AWD/4WD)، والسيارات الكهربائية، نستخدم حصراً 'السطحة الهيدروليكية الكاملة' لحماية الهيكل وناقل الحركة من أي احتكاك. أما للسيارات العادية والمسافات القصيرة داخل الشوارع الضيقة، فيمكن استخدام ونش السحب بالشوكة (Wheel-Lift)."
    },
    {
      q: "هل تقدمون خدمات المساعدة على الطريق دون الحاجة لسحب السيارة؟",
      a: "بالتأكيد. نوفر ورش إسعاف طوارئ متنقلة تقدم: شحن وتوصيل البطاريات (Jump Start)، تزويد الوقود عند نفاده، تبديل وتركيب الإطار الاحتياطي، وفحص كمبيوتر سريع لتحديد الأعطال البسيطة في مكانك دون الحاجة لجر السيارة."
    },
    {
      q: "كيف تضمنون عدم تعرض السيارة لأي خدوش أثناء الرفع والنقل؟",
      a: "جميع أوناشنا مزودة بسطحات ذات زوايا ميل صفرية (Zero-Degree Slopes) تلامس الأرض بسلاسة، ونستخدم أحزمة شد بوليستر ناعمة مزدوجة ومعتمدة دولياً تُثبت في العجلات ونقاط الشاسيه المخصصة من المصنع دون ملامسة الصدادات أو الدهان الخارجي."
    },
    {
      q: "هل يمكنكم نقل السيارات بين المحافظات والموانئ؟",
      a: "نعم، نقدم خدمة النقل الآمن بين جميع محافظات مصر (من القاهرة إلى الإسكندرية، الساحل الشمالي، العين السخنة، الغردقة، شرم الشيخ، ومحافظات الصعيد والدلتا)، وكذلك شحن ونقل السيارات للموانئ والمطارات مع توفير تتبع مباشر عبر GPS وتأمين شامل."
    },
    {
      q: "ما هي البيانات المطلوبة عند الاتصال بطلب ونش إنقاذ؟",
      a: "نحتاج فقط إلى: نوع وموديل سيارتك، طبيعة العطل أو الحادث (هل العجلات تدور أم مقفلة؟)، موقعك الحالي (ويفضل مشاركة اللوكيشن عبر واتساب)، والوجهة التي ترغب في نقل السيارة إليها."
    }
  ];

  return (
    <section className="home-pillar-section" aria-label="دليل ونش إنقاذ سيارات مصر">
      <div className="pillar-container">

        {/* Section Header */}
        <div className="pillar-header">
          <div className="pillar-badge">
            <Award size={18} /> دليل خدمات الإنقاذ الشامل والمعتمد في مصر
          </div>
          <h2 className="pillar-main-title">
            أفضل وأسرع ونش إنقاذ سيارات في مصر | خدمة طوارئ 24 ساعة
          </h2>
          <p className="pillar-lead-text">
            سواء تعرضت سيارتك لعطل ميكانيكي مفاجئ، نفاد شحن البطارية، ثقب في الإطارات، أو حادث سير على الطرق السريعة وداخل المدن؛ فإن <strong>ونش إنقاذ محمد بحر</strong> (خبرة منذ 2001) يوفر لك أسرع خدمة إنقاذ وسحب سيارات في القاهرة والجيزة وجميع محافظات مصر بأسطول أوناش حديث مجهز بأحدث تكنولوجيا الرفع الهيدروليكي وبأرخص الأسعار مع خصم 50% فوري وضمان سلامة السيارة بنسبة 100%.
          </p>
        </div>

        {/* Core Value Pillars Grid */}
        <div className="pillar-cards-grid">
          <div className="pillar-card">
            <div className="pillar-card-icon" style={{ background: '#e3f0ff', color: '#0077ff' }}>
              <Clock size={32} />
            </div>
            <h3>استجابة فورية 10–15 دقيقة</h3>
            <p>
              بفضل انتشار أكثر من 40 نقطة تمركز لأوناشنا في الميادين العامة، المخارج الحيوية، وبوابات الطرق الصحراوية، نضمن وصول أقرب ونش إنقاذ إلى موقعك خلال دقائق معدودة.
            </p>
          </div>

          <div className="pillar-card">
            <div className="pillar-card-icon" style={{ background: '#e8f8f0', color: '#10b981' }}>
              <ShieldCheck size={32} />
            </div>
            <h3>أمان تام وتأمين شامل</h3>
            <p>
              نستخدم سطحات هيدروليكية كاملة الانخفاض (Zero-degree) وأحزمة شد ناعمة مزدوجة لضمان رفع ونقل سيارتك بأمان تام دون أي خدش للهيكل أو المكونات السفلية.
            </p>
          </div>

          <div className="pillar-card">
            <div className="pillar-card-icon" style={{ background: '#fffbeb', color: '#f59e0b' }}>
              <DollarSign size={32} />
            </div>
            <h3>تسعيرة ثابتة بدون رسوم خفية</h3>
            <p>
              نقدم أرخص سعر ونش إنقاذ في مصر مع شفافية مطلقة. يتم تحديد التكلفة المتفق عليها مسبقاً قبل تحرك الونش مع تطبيق خصم 50% الفوري وعدم وجود أي إكراميات.
            </p>
          </div>

          <div className="pillar-card">
            <div className="pillar-card-icon" style={{ background: '#fdf2f8', color: '#ec4899' }}>
              <Zap size={32} />
            </div>
            <h3>خدمات صيانة سريعة بالموقع</h3>
            <p>
              لا تقتصر خدماتنا على السحب فقط؛ بل نوفر ورش دعم متنقلة لشحن البطاريات، تزويد وقود الطوارئ، تبديل الإطارات، وفتح الأبواب المغلقة دون كسر الزجاج.
            </p>
          </div>
        </div>

        {/* Regional Emergency Hubs Directory */}
        <div className="pillar-hubs-directory">
          <div className="pillar-sub-header">
            <Navigation size={24} color="#0077ff" />
            <h3>دليل مناطق التغطية ونقاط التمركز الحيوية في القاهرة والجيزة والمحافظات</h3>
          </div>
          <p className="pillar-sub-desc">
            تنتشر أوناشنا على مدار 24 ساعة في أهم القطاعات الجغرافية لتقديم استجابة فورية لسحب وإنقاذ السيارات:
          </p>

          <div className="hubs-grid">
            {regionalHubs.map((hub, idx) => (
              <div key={idx} className="hub-card">
                <div className="hub-card-top">
                  <h4>{hub.title}</h4>
                  <span className="hub-time-badge"><Clock size={14} /> {hub.time}</span>
                </div>
                <div className="hub-roads">
                  <MapPin size={16} color="#0077ff" />
                  <span><strong>أهم المحاور:</strong> {hub.roads}</span>
                </div>
                <p className="hub-desc">{hub.desc}</p>
                <div className="hub-card-bottom">
                  <Link to={hub.link} className="hub-link">
                    تفاصيل المنطقة ونقاط التمركز <ChevronLeft size={16} />
                  </Link>
                  <a href={`tel:+20${phoneNumber}`} className="hub-call-btn">
                    <PhoneCall size={14} /> طلب ونش
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Tow Truck Comparison Table */}
        <div className="pillar-table-wrapper">
          <div className="pillar-sub-header">
            <Truck size={24} color="#0077ff" />
            <h3>جدول مقارنة أنواع أوناش الإنقاذ واستخداماتها الهندسية</h3>
          </div>
          <p className="pillar-sub-desc">
            نمتلك أسطولاً متنوعاً من أحدث معدات وسيارات السحب المصممة للتعامل مع مختلف فئات المركبات وحالات الأعطال:
          </p>

          <div className="table-responsive">
            <table className="pillar-table">
              <thead>
                <tr>
                  <th>نوع ونش الإنقاذ</th>
                  <th>طاقة الرفع والحمولة</th>
                  <th>الفئات المناسبة</th>
                  <th>الميزات ومستوى الأمان</th>
                  <th>الاستخدام المثالي</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><strong>السطحة الهيدروليكية (Flatbed)</strong></td>
                  <td>تصل إلى 4.5 طن</td>
                  <td>السيارات الفارهة، الرياضية، والـ SUV</td>
                  <td>حماية كاملة 100% من الاحتكاك، زاوية صعود صفرية</td>
                  <td>النقل لمسافات طويلة، نقل سيارات جديدة، السحب الآمن</td>
                </tr>
                <tr>
                  <td><strong>ونش السحب بالشوكة (Wheel-Lift)</strong></td>
                  <td>تصل إلى 3.5 طن</td>
                  <td>السيارات السيدان، الهاتشباك، والتاكسي</td>
                  <td>سرعة فائقة في التحميل والرفع من العجلات الأمامية/الخلفية</td>
                  <td>أعطال الشوارع المزدحمة، السحب للمسافات القصيرة</td>
                </tr>
                <tr>
                  <td><strong>ونش الإنقاذ الثقيل (Heavy Duty)</strong></td>
                  <td>تصل إلى 25 طن</td>
                  <td>المعدات الثقيلة، الميني باص، والكرفانات</td>
                  <td>روافع هيدروليكية عملاقة وسلاسل فولاذية معتمدة</td>
                  <td>سحب الشاحنات، انتشال حوادث الطرق السريعة والانقلابات</td>
                </tr>
                <tr>
                  <td><strong>ونش الجراجات والأماكن الضيقة</strong></td>
                  <td>تصل إلى 2.5 طن</td>
                  <td>السيارات الصغيرة والمتوسطة</td>
                  <td>ارتفاع منخفض وقدرة فائقة على المناورة في الجراجات السفلية</td>
                  <td>سحب السيارات من المواقف تحت الأرض (Underground Parking)</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Troubleshooting & Emergency Triage Guide */}
        <div className="pillar-triage-wrapper">
          <div className="pillar-sub-header">
            <Wrench size={24} color="#0077ff" />
            <h3>دليل التشخيص السريع والتصرف الأولي عند حدوث عطل مفاجئ</h3>
          </div>
          <p className="pillar-sub-desc">
            قبل طلب ونش الإنقاذ، إليك كيفية تشخيص أكثر الأعطال شيوعاً والتصرف الصحيح للحفاظ على سلامتك ومحرك سيارتك:
          </p>

          <div className="triage-grid">
            <div className="triage-card">
              <div className="triage-card-header">
                <Gauge size={22} color="#ef4444" />
                <h4>🌡️ ارتفاع حرارة المحرك المفاجئ (Overheating)</h4>
              </div>
              <p>
                <strong>ماذا تفعل؟</strong> اوقف السيارة فوراً في أقصى اليمين واطفئ المحرك. <strong>تحذير هام:</strong> لا تفتح غطاء قربة الردياتير نهائياً أثناء سخونة المحرك لتجنب الحروق الخطيرة. انتظر 20 دقيقة ثم افحص مستوى سائل التبريد، وإذا كان هناك تسريب مستمر، اطلب ونش سطحة فوراً لتجنب تلف وش السلندر.
              </p>
            </div>

            <div className="triage-card">
              <div className="triage-card-header">
                <BatteryCharging size={22} color="#3b82f6" />
                <h4>⚡ بطارية فارغة أم تلف في الدينامو؟ (Battery vs Alternator)</h4>
              </div>
              <p>
                <strong>كيف تفرق؟</strong> إذا سمعت صوت طقطقة متكرر عند إدارة المفتاح دون دوران المحرك، فالمشكلة في البطارية (نوفر خدمة شحن متنقلة فورية). أما إذا انطفأت السيارة فجأة أثناء السير مع إضاءة لمبة البطارية، فالعطل من الدينامو وتتطلب السيارة سحباً إلى مركز الصيانة.
              </p>
            </div>

            <div className="triage-card">
              <div className="triage-card-header">
                <ShieldCheck size={22} color="#10b981" />
                <h4>⚙️ قفل ناقل الحركة الأوتوماتيكي (Shift Lock Release)</h4>
              </div>
              <p>
                <strong>كيف تحرر الفتيس؟</strong> إذا توقفت السيارة تماماً وعلق الفتيس على وضع (P)، استخدم زر أو فتحة (Shift Lock Release) الصغيرة بجوار عصا الفتيس بالضغط عليها بمفتاح السيارة لتحريك العصا إلى وضع (N) المحايد لتمكين الونش من سحبها دون إتلاف التروس.
              </p>
            </div>

            <div className="triage-card">
              <div className="triage-card-header">
                <Key size={22} color="#8b5cf6" />
                <h4>🔑 غلق الأبواب والمفتاح بالداخل (Car Lockout)</h4>
              </div>
              <p>
                <strong>الحل الآمن:</strong> لا تحاول كسر الزجاج أو استخدام أسلاك عشوائية قد تتلف الحساسات ومجاري النوافذ. فريقنا مجهز بأحدث وسائد الهواء والأدوات الاحترافية المعتمدة لفتح أبواب السيارات في دقيقتين بأمان تام وبدون أي خدوش.
              </p>
            </div>
          </div>
        </div>

        {/* Specialized Vehicles Protocol (EV, Low Sports, 4WD) */}
        <div className="pillar-specialized-wrapper">
          <div className="pillar-sub-header">
            <ShieldCheck size={24} color="#0077ff" />
            <h3>بروتوكولات سحب وإنقاذ السيارات الحديثة والفاخرة والكهربائية</h3>
          </div>
          <div className="specialized-grid">
            <div className="specialized-card">
              <h4>⚡ السيارات الكهربائية والهايبرد (EVs)</h4>
              <p>
                تحظر الشركات المصنعة (Tesla, Porsche Taycan, BMW i) سحب السيارات الكهربائية بالجر على الأرض لأن دوران العجلات يولد تياراً كهربائياً عكسياً يتلف المحركات والبطارية. نقوم بنقلها حصراً على سطحات هيدروليكية كاملة.
              </p>
            </div>
            <div className="specialized-card">
              <h4>🏎️ السيارات الرياضية والمنخفضة (Low Profile)</h4>
              <p>
                نستخدم سطحات هيدروليكية تنزل بزاوية صفرية على الأرض (Zero-Clearance) مع وصلات إضافية مبطنة بالمطاط لحماية الإكصدام والسبويلر الأمامي والهيكل السفلي من أي احتكاك.
              </p>
            </div>
            <div className="specialized-card">
              <h4>🚙 سيارات الدفع الرباعي المستمر (Full-Time 4WD / AWD)</h4>
              <p>
                تتطلب سيارات الدفع الرباعي (Jeep, Range Rover, Subaru) التحميل الكامل على السطحة لحماية علبة التروس التفاضلية (Differential) ومنع تلف ناقل الحركة الناتج عن دوران محور واحد فقط.
              </p>
            </div>
          </div>
        </div>

        {/* 4-Step Rescue Workflow */}
        <div className="pillar-steps-wrapper">
          <div className="pillar-sub-header">
            <ArrowDownCircle size={24} color="#0077ff" />
            <h3>خطوات طلب ونش الإنقاذ وسحب السيارة خطوة بخطوة</h3>
          </div>

          <div className="pillar-steps-grid">
            <div className="step-card">
              <div className="step-number">1</div>
              <h4>الاتصال وتحديد الموقع</h4>
              <p>اتصل بنا على <a href={`tel:+20${phoneNumber}`}>{phoneNumber}</a> أو أرسل موقعك المباشر عبر واتساب لتحديد نقطة العطل بدقة.</p>
            </div>

            <div className="step-card">
              <div className="step-number">2</div>
              <h4>توجيه أقرب ونش فوراً</h4>
              <p>يتم تحريك أقرب ونش متمركز في نطاقك الجغرافي مع إبلاغك باسم السائق ورقم الونش ووقت الوصول التقريبي (10–15 دقيقة).</p>
            </div>

            <div className="step-card">
              <div className="step-number">3</div>
              <h4>التأمين والرفع الاحترافي</h4>
              <p>يقوم الفني بتأمين مسار الطريق ورفع السيارة بسلاسة باستخدام الأحزمة الهيدروليكية دون التسبب في أي احتكاك للصدادات.</p>
            </div>

            <div className="step-card">
              <div className="step-number">4</div>
              <h4>النقل والتسليم الآمن</h4>
              <p>نقل السيارة إلى مركز الصيانة، التوكيل، أو وجهتك المختارة مع تقديم تقرير فني وفاتورة رسمية معتمدة.</p>
            </div>
          </div>
        </div>

        {/* Driver Emergency Safety Box */}
        <div className="pillar-safety-box">
          <div className="safety-header">
            <AlertTriangle size={28} color="#f59e0b" />
            <h3>إرشادات السلامة الحيوية عند تعطل السيارة على الطريق السريع</h3>
          </div>
          <ul className="safety-list">
            <li>
              <CheckCircle2 size={20} color="#10b981" />
              <span><strong>التزم أقصى اليمين:</strong> حاول توجيه السيارة فوراً إلى الحارة اليمنى أو كتف الطريق الآمن (Emergency Lane).</span>
            </li>
            <li>
              <CheckCircle2 size={20} color="#10b981" />
              <span><strong>شغّل أضواء التحذير (الفلاشر):</strong> لتنبيه السائقين القادمين من الخلف خاصة في الفترات الليلية أو أثناء الشبورة.</span>
            </li>
            <li>
              <CheckCircle2 size={20} color="#10b981" />
              <span><strong>ضع مثلث الطوارئ العاكس:</strong> على مسافة لا تقل عن 50 إلى 100 متر خلف السيارة لإتاحة مسافة رؤية كافية.</span>
            </li>
            <li>
              <CheckCircle2 size={20} color="#10b981" />
              <span><strong>انتظر خلف الحواجز الخرسانية:</strong> انزل من السيارة أنت والركاب وقف خلف حواجز الأمان بعيداً عن نهر الطريق.</span>
            </li>
            <li>
              <CheckCircle2 size={20} color="#10b981" />
              <span><strong>اتصل بونش إنقاذ محمد بحر فوراً:</strong> على الرقم <strong>{phoneNumber}</strong> لتوجيه أقرب وحدة إنقاذ وتأمين موقعك.</span>
            </li>
          </ul>
        </div>

        {/* Comprehensive Interactive FAQ Accordion */}
        <div className="pillar-faq-wrapper">
          <div className="pillar-sub-header">
            <Sparkles size={24} color="#0077ff" />
            <h3>موسوعة الأسئلة الشائعة حول ونش إنقاذ السيارات في مصر</h3>
          </div>
          <p className="pillar-sub-desc">
            إليك إجابات تفصيلية وشاملة عن أكثر الاستفسارات والأسئلة شيوعاً عند طلب خدمة الإنقاذ والسحب:
          </p>

          <div className="faq-accordion-list">
            {detailedFaqs.map((faq, idx) => (
              <div 
                key={idx} 
                className={`faq-accordion-item ${activeFaq === idx ? 'open' : ''}`}
                onClick={() => toggleFaq(idx)}
              >
                <button className="faq-question-btn" aria-expanded={activeFaq === idx}>
                  <span>{faq.q}</span>
                  {activeFaq === idx ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                </button>
                {activeFaq === idx && (
                  <div className="faq-answer-content">
                    <p>{faq.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Pricing Transparency Banner & Link to Flagship Guide */}
        <div className="pillar-pricing-cta">
          <div className="pricing-cta-content">
            <h3>هل ترغب في معرفة أسعار ونش الإنقاذ بالتفصيل لعام 2026؟</h3>
            <p>
              اطلع على دليلنا الرسمي المفصل الذي يشمل جداول التكلفة التقديرية حسب المسافة، نوع المركبة، وحاسبة نقل السيارات بين المحافظات.
            </p>
          </div>
          <div className="pricing-cta-actions">
            <Link to="/articles/اسعار-ونش-انقاذ-2026" className="pillar-btn-primary">
              عرض جدول أسعار 2026 <ChevronLeft size={18} />
            </Link>
            <a href={`tel:+20${phoneNumber}`} className="pillar-btn-secondary">
              <PhoneCall size={18} /> اتصال مباشر: {phoneNumber}
            </a>
          </div>
        </div>

      </div>
    </section>
  );
};

export default HomePillarContent;
